import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useAuthContext } from '@/contexts/authContext';
import { UserRole } from '@/model/User.model';
import { publicRoutes } from '@/router/routes';

const InternalAdminAppRoot = () => {
  const navigate = useNavigate();
  const { user, isAuthenticating, isLogin } = useAuthContext();

  useEffect(() => {
    if (isLogin && user) {
      if (user.role !== UserRole.Admin) {
        alert('You do not have permission to visit this page. Please login');
        navigate(publicRoutes.Login.getRoute());
      }
    } else if (!isAuthenticating) {
      navigate(publicRoutes.Login.getRoute());
    }
  }, [isAuthenticating, user, navigate, isLogin]);

  return <Outlet />;
};

export default InternalAdminAppRoot;
